
import moment from "moment";
import PageDetailHeader from '@/components/core/PageDetailHeader';
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import loaderComponent from '@/components/loaderComponent'
import EventCardGeneral from '@/components/EventCardGeneral.vue';
import googleAd from '@/components/gAdUnitCode'
import Share from '@/components/Share'
import FaqCardPost from '@/components/FaqCardPost';
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
export default {
  layout: 'details-page',
  components: {
    PageDetailHeader,
    VueSlickCarousel,
    loaderComponent,
    EventCardGeneral,
    googleAd,
    Share,
    FaqCardPost,
    CoolLightBox
  },
  head() {
    return {
      title: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
      meta: [{
        hid: 'description',
        name: 'description',
        content: this.metaDesc()
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: this.metaKeywords()
      },
      {
        hid: 'image',
        property: 'image',
        content: this.metaImage()
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.metaImage()
      },
      {
        hid: 'og:image:secure_url',
        property: 'og:image:secure_url',
        content: this.metaImage()
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: this.metaDesc()
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
      },
      {
        hid: 'twitter:image',
        name: 'twitter:image',
        content: this.metaImage()
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: this.metaDesc()
      }
      ],
    }
  },
  scrollToTop: true,
  data() {
    return {
      activitySlug: null,
      listings: null,
      relatedListings: null,
      categoriesArr: null,
      eventDate: null,
      loading: true,
      listingLoading: true,
      // Form submit variables
      gallerySmall: {
        infinite: true,
        slidesToShow: 7,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        focusOnSelect: true,
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 490,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        ]
      },
      galleryBig: {
        infinite: true,
        autoplay: false,
        speed: 400,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
      seoData: null,
      rating: 5,
      todaysDate: new Date(),
      selectedSec: "description",
      index: null,
    }
  },
  jsonld() {
    if (!this.listings) {
      return null;
    }
    let structure = {
        "@context": "http://schema.org"
      }

    let schemaData = [
    {
          "@type": "ImageObject",
          "@id": this.metaImage(),
          "url": this.metaImage(),
          "contentUrl": this.metaImage(),
          "caption": this.seoData && this.seoData.title ? this.seoData.title : 'Events on Goa App',
          "inLanguage": "en-US",
          "width": 800,
          "height": 440
    },
    {
    "@type": "Event",
      "name": this.seoData && this.seoData.title ? this.seoData.title : 'Event Goa App',
      "url": "https://goa.app/event/" + this.activitySlug,
      "description": this.metaDesc(),
      "image": this.listings && this.listings && this.listings.gallery && this.listings.gallery.length >
        0 ? this.listings.gallery[0] : [],
      "startDate": this.listings && this.listings.startDate ? this.listings.startDate : this.todaysDate,
      "endDate": this.listings && this.listings.endDate ? this.listings.endDate : this.todaysDate,
      "doorTime": this.listings && this.listings.startDate ? this.listings.startDate : this.todaysDate,
      "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
      "eventStatus": "http://schema.org/EventScheduled",
      "doorTime": this.listings && this.listings.startDate ? this.listings.startDate : this.todaysDate,
      "scheduleTimezone": "Asia/Kolkata",
      "location": {
        "@type": "Place",
        "name": this.listings && this.listings.location ? this.listings.location : 'Goa',
        "address": {
          "@type": "PostalAddress",
          "streetAddress": this.listings && this.listings.state ? this.listings.state.name : 'Goa',
          "addressLocality": this.listings && this.listings.location ? this.listings.location : 'Goa',
          "addressCountry": {
            "@type": "Country",
            "name": "India"
          }
        }
      },
      "offers": {
        "@type": "Offer",
        "availability": "http://schema.org/InStock",
        "name": "Event Pass",
        "price": this.listings && this.listings.price ? this.listings.price : 0,
        "priceCurrency": "INR",
        "validFrom": this.listings && this.listings.createdAt ? this.listings.createdAt : this.todaysDate,
        "url": "https://goa.app/event/" + this.activitySlug,
        "inventoryLevel": {
          "@type": "QuantitativeValue",
          "value": "25",
        }
      },
      "performer": {
        "@type": "PerformingGroup",
        "name": this.listings && this.listings.name ? this.listings.name : 'Goa App',
      },
      "organizer": {
        "@type": "Organization",
        "name": this.listings && this.listings.hostname ? this.listings.hostname : 'Goa App Events',
        "url": this.listings && this.listings.link ? this.listings.link : 'https://goa.app/event',
      }
    },
    {
  "@type": "Article",
  "@id": "https://goa.app/event/" + this.activitySlug,
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://goa.app/event/" + this.activitySlug
  },
  "headline": this.listings && this.listings.name 
              ? this.listings.name 
              : "Event Goa App",
  "name": this.seoData && this.seoData.title ? this.seoData.title : 'Event Goa App',
  "description": this.metaDesc(),
  "keywords": this.metaKeywords(),
  "datePublished": this.listings && this.listings.createdAt 
                   ? this.listings.createdAt 
                   : "2025-01-04T11:39:55.419Z",
  "dateModified": this.listings && this.listings.createdAt
                  ? this.listings.createdAt
                  : "2025-01-04T11:39:55.419Z",
  "author": {
    "@type": "Person",
    "name": "Goa App",
    "url": "https://goa.app"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Goa App",
    "logo": {
      "@type": "ImageObject",
      "url": "https://goa.app/goa-app-logo.svg",
      "width": 317,
      "height": 207
    }
  },
  "image": {
    "@type": "ImageObject",
    "@id": this.metaImage(),
    "url": this.metaImage(),
    "width": 800,
    "height": 440
  }
}
]
    //For FAQ schema
    let faqSchema = null ;
      if(this.faqSchemaItems){
        faqSchema = {
            '@type': 'FAQPage',
            mainEntity: this.faqSchemaItems,
        }
        schemaData.push(faqSchema)
      }
      let ds = {
        "@graph": schemaData
      }
      return { ...structure, ...ds };
  },
  async validate({
    params,
    store
  }) {
    // await operations
    if (params.slug != (null || "")) {
      this.activitySlug = params.slug;
      return true // if the params are valid
    } else {
      return false // will stop Nuxt.js to render the route and display the error page
    }
  },
  async asyncData({ error, route, $axios }) {
    try {
      let data = await $axios.get('/api/events/seo/getSEOContent/' + route.params.slug)
    } catch {
      error({ statusCode: 404, message: 'Post not found' })
    }
  },
  created() {
    this.activitySlug = this.$route.params.slug;
    this.$fetch();
  },
  mounted() {
    this.getAllData();
  },
  beforeDestroy() {
    // Remove the scroll listener when the component is destroyed
    window.removeEventListener('scroll', this.onScroll);
  },
  destroyed() {
    if (document.getElementById('bookingClose'))
      document.getElementById('bookingClose').click();
    if (document.getElementById('venueSelectClose'))
      document.getElementById('venueSelectClose').click();
  },
  async fetch() {
    this.seoData = await fetch(this.$config.fetchUrl + '/api/events/seo/getSEOContent/' + this.activitySlug)
      .then(res => res.json()).catch(error => {
        //this.$router.push({
//          path: '/'
//        })
        console.error("There was an error!", error); return false;
      });
  },
  methods: {
    async getAllData() {
      //Get the list of post data
      this.listings = await fetch(this.$config.fetchUrl + '/api/events/' + this.activitySlug)
        .then(res => res.text()).catch(error => {
          this.$router.push({
            path: '/'
          })
          console.error("There was an error!", error); return false;
        });
      let items = this.getCryptKey(this.listings);
      if (items && items.event)
        this.listings = items.event;

        if(this.listings && this.listings && this.listings.faq  && this.listings.faq.length > 0){
                this.faqSchemaItems = this.listings.faq.map((item, index) => ({
                    '@type': 'Question',
                    position: index + 1,
                    "name":item.title,
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text":  item.description
                    },
                }));
            }
      if (items && items.similarEvents)
        this.relatedListings = items.similarEvents;
      if (this.listings.categories && this.listings.categories.length > 0)
        this.categoriesArr = this.listings.categories.map((el) => el.name).join(', ');
      this.eventDate = this.getDateOfEvent(this.listings)
      this.$nextTick(() => {
        this.loading = false;
        window.addEventListener('scroll', this.onScroll);
      })
    },


    //Moves the active class for the tabs on page scroll
    onScroll() {
      const sections = document.querySelectorAll(".scrollonsections");
      var activeIndex = this.selectedSec;

      sections.forEach((section, index) => {
        const rect = section.getBoundingClientRect();
        // Check if the section is in the viewport (top of section is within the window)
        if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
          activeIndex = section.id;
        }
      });
      // Update active tab if necessary
      if (activeIndex !== this.activeTab) {
        this.selectedSec = activeIndex;
      }
    },

    getLink(link) {
      return link.startsWith("http://") || link.startsWith("https://") ? link : `http://${link}`;
    },
    getDateOfEvent(item) {
      if (item && item.startDate && item.endDate) {
        if (moment(item.startDate).utc().format('DD/MM/YYYY') == moment(item.endDate).utc().format('DD/MM/YYYY'))
          return moment(item.startDate).utc().format('DD MMM YY')
        else if (moment(item.startDate).utc().format('MM/YYYY') == moment(item.endDate).utc().format('MM/YYYY')) {
          return `${moment(item.startDate).utc().format('DD')} - ${moment(item.endDate).utc().format('DD MMM YY')}`
        } else if (moment(item.startDate).utc().format('YYYY') == moment(item.endDate).utc().format('YYYY')) {
          return `${moment(item.startDate).utc().format('DD MMM')} - ${moment(item.endDate).utc().format('DD MMM YY')}`
        } else {
          return `${moment(item.startDate).utc().format('DD MMM YY')} - ${moment(item.endDate).utc().format('DD MMM YY')}`
        }
      } else {
        return ''
      }
    },
    checkEndDate(startDate, endDate) {
      if (startDate && endDate) {
        if (moment(startDate).utc().format('DD/MM/YYYY') == moment(endDate).utc().format('DD/MM/YYYY'))
          return null
        else {
          return `${moment(endDate).utc().format('ddd')}, ${moment(endDate).utc().format('ll')}`
        }
      } else {
        return ''
      }
    },
    metaDesc() {
      if (this.seoData && this.seoData.description) {
        return this.seoData.description
      } else {
        return 'Looking for the must visit places and must do activities in Goa ? Goa App offers all that you need to know about the Beaches, Old Goa Churches Dudhsagar Waterfalls Tour, Parasailing, Watersports Activities, Scuba Diving, Grand Island Tour, Car Rentals etc. Check out the top things to do in Goa only on Goa App.'
      }
    },
    metaKeywords() {
      if (this.seoData && this.seoData.keywords) {
        return this.seoData.keywords;
      } else {
        return 'Goa, Goa Tourism, Travel Guide, Watersports, must visit places, Must do activities, Watesports, Scuba diving, Parasailing, Dudhsagar Waterfalls Tour, Grand Island Goa, Cheap, Discount, Old Goa Churches, Offers, Travel Goa, Visit goa, Car rentals, Bike Rentals, Top things to do in Goa, Travel Agency'
      }
    },
    metaImage() {
      if (this.seoData && this.seoData.image) {
        return this.seoData.image;
      } else {
        return 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-12-14T06%3A34%3A55.402Zbeaches.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=L%2FFNG4DzwiyU1H%2BoK2pdHPxA4qkomya%2BxGZmJq2vCtr7Y4l74qnAn8Tk8Cz1mUNsV%2F7%2FEAKRpl0thh8wvSgb8vqvaA3Wk0TO%2FLp%2FRbqF5wDyixmv90TsYvNguZQAx0BmaE9W0AMQNOiVWG5AfYa2pyyyYhYO6Z3aXQ25biU1%2BjjYZ8NMto47ea4UuyC2btEEDU1IK9GivCXtxlcFDC3xEC80EbMub0mIowfGV2EQ0Nr3Dm0kOLurIx5jy%2Ba1oVAB2Eu3MzLIp%2B1Nm%2BnleN%2FaHTp5pWmj2y7VNqbjtA8wcw94Q1rL1b7FXSsHuxBmNABsdt3INpqGVpT%2BhO2G7iphbg%3D%3D'
      }
    },
    syncSliders(currentPosition, nextPosition) {
      this.$refs['slick1'].goTo(nextPosition)
      this.$refs['slick2'].goTo(nextPosition)
    },
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/thumbnail-square.svg`)
    },
    getLatLongForMap() {
        if (this.listings && this.listings.longitude && this.listings.latitude) {
          return this.listings.latitude + "," + this.listings.longitude
        }
        return ""
      },
      getDirectionsUrl() {
      if (this.listings && this.listings.latitude && this.listings.longitude) {
        return window.open(
          `https://www.google.com/maps/dir/?api=1&destination=${this.listings.latitude},${this.listings.longitude}`,
          '_blank')
      }
      return ""
    },
     // Store filters in Localstorage
     scrollHere(item) {
      this.$nextTick(() => {
        this.scrollToJsEvents(item);
      });
    },
  }
}
